export { default, Grid2Props } from '@mui/material/Unstable_Grid2';
